export enum AdminDepositWithdrawalStatus {
  completed = "completed",
  reject = "reject",
  progress = "progress",
  pending = "pending",
  in_work = "in_work",
  waiting = "waiting",
  deleted = "deleted",
}
